/**
 * @flow
 * @format
 */

import _BomWrapper from './BomWrapper';

export default _BomWrapper;



// WEBPACK FOOTER //
// ./src/components/BomWrapper/index.js